import React from 'react';
import styles from './Navbar.module.scss';
import reducer from './navbar-reducer';
import Constant from '../../constants';
import logo from '../../images/logo.svg';
import searchButton from '../../images/searchButton.svg';
import { FaAlignJustify } from 'react-icons/fa';
import { IoHomeOutline } from 'react-icons/io5';
import { useAppContext } from '../../app-context';
import { Link } from 'react-router-dom';
import Sidebar from '../sidebar/Sidebar';
import connections from '../../images/high-five.svg';
import chat from '../../images/comment.svg';
import notifications from '../../images/active.svg';
import profilePicture from '../../images/Saransh.jpg';

const initialState = {
  searchText: '',
};

const Navbar = () => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const {
    authenticated,
    selectedPage,
    sidebarOpen,
    toggleSidebar,
    handleLogin,
  } = useAppContext();
  return (
    <nav className={styles.navbar}>
      <section className={styles.logo}>
        <Link to='/'>
          <img className={styles.logoIcn} src={logo} alt='alpha-omega' />
          <span className={styles.website}>{Constant.WEBSITE_NAME}</span>
        </Link>
        <FaAlignJustify className={styles.menuIcn} onClick={toggleSidebar} />
      </section>
      <form
        className={styles.searchBar}
        onSubmit={(event) => dispatch({ type: 'SEARCH_VALUE', payload: event })}
      >
        <input
          className={styles.searchInput}
          placeholder='Search'
          id='search'
          value={state.searchText}
          onChange={(event) =>
            dispatch({
              type: 'SEARCH_TEXT_CHANGE',
              payload: event,
            })
          }
        />
        <img src={searchButton} className={styles.searchBtn}></img>
      </form>
      <section className={styles.menu}>
        <Link to={Constant.HOME_PAGE_ROUTE}>
          {!authenticated && (
            <h2
              className={`${
                selectedPage === Constant.HOME_PAGE_ROUTE
                  ? styles.underline
                  : null
              }`}
            >
              {Constant.HOME_PAGE}
            </h2>
          )}
          {authenticated && (
            <IoHomeOutline
              className={`${
                selectedPage === Constant.HOME_PAGE_ROUTE
                  ? styles.underline
                  : null
              }`}
            />
          )}
        </Link>
        {!authenticated && (
          <Link to={Constant.SIGNUP_PAGE_ROUTE}>
            <h2
              className={`${
                selectedPage === Constant.SIGNUP_PAGE_ROUTE
                  ? styles.underline
                  : null
              }`}
            >
              {Constant.SIGNUP_PAGE}
            </h2>
          </Link>
        )}
        {authenticated && (
          <Link to={Constant.CONNECTIONS_PAGE_ROUTE}>
            <img
              src={connections}
              className={`${
                selectedPage === Constant.CONNECTIONS_PAGE_ROUTE
                  ? styles.connections + ' ' + styles.underline
                  : styles.connections
              }`}
            />
          </Link>
        )}
        {!authenticated && (
          //To be changed to login page -> then login
          <Link to={Constant.PROFILE_PAGE_ROUTE}>
            <h2
              onClick={() => handleLogin()}
              className={`${
                selectedPage === Constant.PROFILE_PAGE_ROUTE
                  ? styles.underline
                  : null
              }`}
            >
              {Constant.LOGIN_PAGE}
            </h2>
          </Link>
        )}
        {authenticated && (
          <Link to={Constant.CHAT_PAGE_ROUTE}>
            <img
              src={chat}
              className={`${
                selectedPage === Constant.CHAT_PAGE_ROUTE
                  ? styles.chat + ' ' + styles.underline
                  : styles.chat
              }`}
            />
          </Link>
        )}
        {!authenticated && (
          <Link to={Constant.CONTACT_PAGE_ROUTE}>
            <h2
              className={`${
                selectedPage === Constant.CONTACT_PAGE_ROUTE
                  ? styles.underline
                  : null
              }`}
            >
              {Constant.CONTACT_PAGE}
            </h2>
          </Link>
        )}
        {authenticated && (
          <Link to={Constant.NOTIFICATIONS_PAGE_ROUTE}>
            <img
              src={notifications}
              className={`${
                selectedPage === Constant.NOTIFICATIONS_PAGE_ROUTE
                  ? styles.chat + ' ' + styles.underline
                  : styles.chat
              }`}
            />
          </Link>
        )}
        {authenticated && (
          <Link to={Constant.PROFILE_PAGE_ROUTE}>
            <img src={profilePicture} className={styles.profile} />
          </Link>
        )}
      </section>
    </nav>
  );
};

export default Navbar;
